import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { PremissaQuestionario } from '../models/premissa-questionario';
import { PremissasOrcPed } from '../models/premissas-orc-ped';
import { PremissasSistema } from "../models/premissas-sistema";
import { Observable } from "rxjs";
import { EstruturasPersonalizadas } from '../models/estruturas-personalizadas';
import { PremissasUsuario } from '../models/premissas-usuario';

@Injectable({
  providedIn: 'root'
})
export class PremissasService {

  constructor(private http: HttpClient) { }

  consultarPremissas() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BuscarPremissas');
  }

  salvarPremissas(premissas) {
    return this.http.post(globals.apiUrl + '/api/Empresa/SalvarPremissas', premissas);
  }

  textoKitFechado() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoKitFechado');
  }

  textoNovoKitPronto() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoNovoKitPronto');
  }

  textoNovoKitPlus2() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoNovoKitPlus2');
  }

  textoMonteSeuKit() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoMonteSeuKit');
  }

  textoAvulso() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoAvulso');
  }

  validarKitCustomizado() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ValidarKitCustomizado');
  }

  consultarRegraValidacaoKitPersonalizado() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/RegraValidacaoKitPersonalizado');
  }

  consultarCnaes() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/Cnaes');
  }

  consultarTelhadaNaCalculadora() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TelhadoCalc');
  }

  consultarFornecedorPadrao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FornEstruturaPadrao');
  }

  consultarCadastrarPessoaFisica() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CadIntFisico');
  }

  consultarTaxaRural() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TxRural');
  }

  consultarFreteMinimo() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FreteMinimo');
  }

  consultarUsarTbFrete() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarTbFrete');
  }

  consultarDadosObgMonitores() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DadosObgMonitores');
  }

  consultarVerPrecoProdutos() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VerPrecoProdutos');
  }

  consultarVendedorPadrao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VendedorPadrao');
  }

  consultarMostrarVendaAvulso() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarVendaAvulso ');
  }
  consultarDescontoPadrao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DescPadrao ');
  }
  consultarFreteAutomatico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FreteAut ');
  }

  consultarNfeCobranca() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/NfeCobranca ');
  }
  consultarTipoCalculo() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TipoCalculo ');
  }
  consultarTxVendaDireta() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TxVendaDireta ');
  }

  textoFidelidade() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TextoFidelidade');
  }

  consultarUsarFidelidade() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarFidelidade ');
  }

  consultarDesativarPaisagem() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DesativarPaisagem ');
  }

  consultarMonConferencia() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonConferencia ');
  }

  consultarMonIntegracao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonIntegracao ');
  }

  consultarMonTriagemPendencia () {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonTriagemPendencia ');
  }

  consultarMostrarCodErp() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarCodErp ');
  }

  consultarObsNoItem() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ObsNoItem ');
  }

  consultarUsarPrecoAvulso() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarPrecoAvulso ');
  }

  consultarCompConfObg() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CompConfObg ');
  }

  consultarNovoEndEntrega() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/NovoEndEntrega ');
  }

  consultarIntegradorAnexar() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntegradorAnexar ');
  }

  consultarMostrarVenContato() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarVenContato');
  }

  consultarMostrarDadosFinanceiros() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarDadosFinanceiros');
  }

  consultarMostrarBifasico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarBifasico');
  }

  consultarMultiFornecedores() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MultiFornecedores');
  }

  consultarUsarCombImp() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarCombImp');
  }

  consultarLimiteRepasse() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/LimiteRepasse');
  }

  consultarUsarTelCeramico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarTelCeramico');
  }

  consultarUsarTransformador() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarTransformador');
  }

  consultarUsarCombInvStrCon() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarCombInvStrCon');
  }

  consultarMostrarNumeroSerie() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarNumeroSerie');
  }

  consultarAlterarValorFinal() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/AlterarValorFinal');
  }

  consultarMostrarCotacaoDolar() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarCotDolar');
  }

  consultarKitProntoFrete() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/KitProntoFrete');
  }

  consultarKitProntoDesconto() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/KitProntoDesconto');
  }

  consultarEstruturasPersonalizadas() {
    return this.http.get<EstruturasPersonalizadas>(globals.apiUrl + '/api/Empresa/BuscarEstruturasPersonalizadas');
  }

  consultarPodeAdicionarProdutoKitPronto() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/AdProdKitPronto');
  }

  consultarConfirmarSemValidar() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ConfirmarSemValidar');
  }

  consultarAtivarVoucher() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/AtivarVoucher');
  }

  consultarBoletoFotus() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BoletoFotus');
  }

  consultarBloqClonar() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BloqClonar');
  }

  consultarBloqExcluirAnexo() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BloqExcluirAnexo');
  }

  consultarMostrarRecebimentosDashboard() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarRecebimentosDashboard');
  }

  consultarIntegradorPodeVerValorServico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntegVerVlServico');
  }

  consultarCentroDeDistribuicao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CentroDeDistribuicao');
  }

  consultarDispEstoque() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DispEstoque');
  }

  consultarVendAlterarFrete() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VendAlterarFrete');
  }

  consultarUsarDescarga() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarDescarga');
  }

  consultarQuestionario() {
    return this.http.get<PremissaQuestionario>(globals.apiUrl + '/api/Empresa/Questionario');
  }

  consultarUsarServicoEntrega() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarServicoEntrega');
  }

  consultarUsarSeguro() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarSeguro');
  }

  consultarUsarValorProjeto() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarValorProjeto');
  }

  consultarFreteManualAvulso() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FreteManualAvulso');
  }

  consultarFreteAdicionarServico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FreteAdicionarServico');
  }

  consultarFreteAdicionarSeguro() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/FreteAdicionarSeguro');
  }

  consultarUsarEstoqueMinimo() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarEstoqueMinimo');
  }

  consultarUsarMultiFormaPagamento() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarMultiFormaPagamento');
  }

  consultarBloqPedidoSemEstoqueDisp() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BloqPedidoSemEstoqueDisp');
  }

  consultarTrocarRazaoPorNomeFantasia() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/TrocarRazaoPorNomeFantasia');
  }

  consultarCodEverest() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CodEverest');
  }

  consultarNaoRespTimePesqCliente() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/NaoRespTimePesqCliente');
  }

  consultarInscricaoEstadualObg() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/InscricaoEstadualObg');
  }

  consultarMostrarDescKit() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarDescKit');
  }

  consultarQtdPainelPorFileira() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/QtdPainelPorFileira');
  }
  consultarMonConferenciaTecnica() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonConferenciaTecnica');
  }

  consultarMonVerificacao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonVerificacao');
  }

  consultarMonAnaliseFinanceira() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonAnaliseFinanceira');
  }

  consultarMonFaturamento() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MonFaturamento');
  }

  consultarUsarAcrescimo() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarAcrescimo');
  }

  consultarOcultarColunaDescricaoFileiras() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/OcultarColunaDescricaoFileiras');
  }

  consultarPedirCodErpIntegracao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/PedirCodErpIntegracao');
  }

  consultarInformarDadosSeparacao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/InformarDadosSeparacao');
  }

  consultarNomeContratoParceria() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/NomeContratoParceria');
  }

  consultarUsarDocuSign() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarDocuSign');
  }

  consultarUsarMarketPlace() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MarketPlace');
  }

  consultarMostrarPesquisaGeral() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarPesquisaGeral');
  }

  consultarVendaProgramada() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VendaProgramada');
  }

  consultarVenDiNaoAltEndPJ() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VenDiNaoAltEndPJ');
  }

  consultarIntPodeAlterarCD() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntPodeAlterarCD');
  }

  consultarIntegracaoSolaryum() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntegracaoSolaryum');
  }

  consultarMostrarMsgTrocaCD() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MostrarMsgTrocaCD');
  }

  consultarEstoqueVirtual() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/EstoqueVirtual');
  }

  consultarAdicionarVariosKitPronto() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/AdicionarVariosKitPronto');
  }

  consultarModulosAtivos() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BuscarModulosAtivos');
  }

  consultarUsarFormulaRepasseCif() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarFormulaRepasseCif');
  }

  consultarDescClienteSobreporVendedor() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DescClienteSobreporVendedor');
  }

  consultarMsgEnderecoAdicional() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/MsgEnderecoAdicional');
  }

  consultarCalcCondPagNoFinal() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CalcCondPagNoFinal');
  }

  consultarPremissasOrcPed() {
    return this.http.get<PremissasOrcPed>(globals.apiUrl + '/api/Empresa/PremissasOrcPed');
  }

  consultarCalcValorFinalSugestao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CalcValorFinalSugestao');
  }

  consultarRemoverItemSugEdicao() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/RemoverItemSugEdicao');
  }

  consultarUsarReservaManual() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarReservaManual');
  }

  consultarDadosSeparacaoObg() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DadosSeparacaoObg');
  }

  consultarVisualizacaoKitFechado() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/VisualizacaoKitFechado');
  }

  crmVisualizarValor() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CRMVisualizarValor');
  }

  crmEditarAtividade() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/CRMEditarAtividade');
  }

  confirmarMudancaEtapa() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ConfirmarMudancaEtapa');
  }

  pergAlterarAtividade() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/PergAlterarAtividade');
  }

  consultarIntegradorPodeAbrirOcorrencia() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntegradorPodeAbrirOcorrencia');
  }

  consultarEstoqueUnicoLote() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/EstoqueUnicoLote');
  }

  consultarValorArredondamento() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ValorArredondamento');
  }

  consultarUsarCRM() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarCRM');
  }

  consultarUsarLojaProdutos() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarLojaProdutos');
  }

  consultarIntegracaoPlataforma() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/IntegracaoPlataforma');
  }

  consultarBloqSistManuProd() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BloquearSistManutencaoProdutos');
  }

  consultarObrigaSelecionarInversorMontarKit() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/ObrigaSelecionarInversorMontarKit');
  }

  consultarExibirLembreteMontarKitVertys() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/BuscarExibirLembreteMontarKitVertys');
  }

  consultarPremissasSistema() {
    return this.http.get<PremissasSistema>(globals.apiUrl + '/api/Premissas/sistema');
  }

  consultarPreencherTelefoneEmailConsultaCnpj() {
    return this.http.get<boolean>(globals.apiUrl + '/api/Premissas/preencherTelefoneEmailConsultaCnpj');
  }

  consultarControleSolicitacaoTokenIntegrador() {
    return this.http.get<boolean>(globals.apiUrl + '/api/Premissas/ControleSolicitacaoTokenIntegrador');
  }

  salvarPremissasSistema(premissas: PremissasSistema) {
    return this.http.put(globals.apiUrl + '/api/Premissas/sistema', premissas);
  }

  consultarDescInicialKit() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/DescInicialKit');
  }


  consultarPremissasUsuario() {
    return this.http.get<PremissasUsuario>(globals.apiUrl + '/api/PremissasUsuario/usuario');
  }

  salvarPremissasUsuario(premissas: PremissasUsuario) {
    return this.http.put(globals.apiUrl + '/api/PremissasUsuario/usuario', premissas);
  }

  consultarUsarFreteIndividualServico() {
    return this.http.get<any>(globals.apiUrl + '/api/Empresa/UsarFreteIndividualServico');
  }


}

